import { COL_PRODUCTION_CALENDAR_DAYS } from '../config/collections'
import { pb } from '../pocketbase'
import type { ProductionCalendarDayRecord } from '../types/records'
import { buildCalendarRecordMap, calendarDateRangeFilter } from './productionCalendar'

export async function fetchCalendarMap(
  fromKey: string,
  toKey: string,
): Promise<Map<string, ProductionCalendarDayRecord>> {
  const list = await pb.collection(COL_PRODUCTION_CALENDAR_DAYS).getFullList<ProductionCalendarDayRecord>({
    filter: calendarDateRangeFilter(fromKey, toKey),
    sort: 'date',
  })
  return buildCalendarRecordMap(list)
}
